import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SearchItem from './SearchItem';
import { translateStaticContent } from '../../../../helpers/translateStaticContent';

class SearchContainer extends Component {
    constructor(props) {
        super(props);
        this.props = props
    }

    render() {
        let searchItems = '';
        const noMatchesValue = translateStaticContent('toCountryInvalidText', 
                               this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc);

        const staticInputValue = translateStaticContent('toCountryText', 
                                 this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc);

        if (this.props.currentInput.length >=2 && this.props.country.length === 0) {
            searchItems = <SearchItem country={noMatchesValue} key={'no-value'} 
            select={this.props.select} isocode={''} validItem={false} />
        } else if (this.props.currentInput.length <=2 || this.props.currentInput.length === 0) {
            searchItems = <SearchItem country={staticInputValue} key={'no-value'} 
            select={this.props.select} isocode={''} validItem={false} />
        } else {
            searchItems = this.props.country.map((country) => 
            <SearchItem country = {country.countryName} key={country.countryIso3} 
                                   select={this.props.select} isocode={country.countryIso3} validItem={true} />)
        }
        return (
            <div className={`search-result ${this.props.show}`}>
                {searchItems}
            </div>
        )
    }
}

export default SearchContainer;

SearchContainer.propTypes = {
    country: PropTypes.array.isRequired,
    show: PropTypes.string,
    select: PropTypes.func.isRequired,
    currentInput: PropTypes.string,
    defaultStaticContentCalc: PropTypes.object,
    activeLangStaticContentCalc: PropTypes.object,
}